module.exports = __webpack_public_path__ + "static/media/about_top.fb544056.jpg";